module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"specific":"Spécifique"},"en":{"specific":"Specific"}}')
  delete Component.options._Ctor
}
